module.exports = __webpack_public_path__ + "img/P150T_weapon_26.da9a6d4f.png";